module.exports = __webpack_public_path__ + "assets/img/av.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/av.jpg
// module id = 1950
// module chunks = 0